import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { Text } from 'react-native-paper'
import { useSocketStatus } from '../../socket/socket.hooks'
import { useTheme } from '../../hooks/theme.hook'

export function OfflineModeBanner() {
  const status = useSocketStatus()
  const { t } = useTranslation('common')
  const theme = useTheme()
  const [showOffline, setShowOffline] = useState(false)
  const latestStatus = useRef(status)

  useEffect(() => {
    latestStatus.current = status
  }, [status])

  useEffect(() => {
    if (status === 'connected') {
      setShowOffline(false)
      return
    }
    const timeoutId = setTimeout(() => {
      if (latestStatus.current === 'connected') {
        return
      }
      setShowOffline(true)
    }, 5000)
    return () => clearTimeout(timeoutId)
  }, [status])

  if (!showOffline) {
    return null
  }

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: theme.colors.surfaceVariant,
        },
      ]}
    >
      <View style={styles.banner}>
        <View style={styles.textColumn}>
          <Text variant="labelLarge" style={styles.title}>
            <MaterialCommunityIcons
              name="wifi-off"
              size={14}
              color={theme.colors.onSurfaceVariant}
              style={styles.icon}
            />
            {t('mode-offline')}
          </Text>
          <Text variant="bodySmall" style={styles.secondary}>
            {t('mode-offline-subtitle')}
          </Text>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingHorizontal: 12,
  },
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  icon: {
    marginRight: 8,
  },
  textColumn: {
    alignItems: 'center',
    flex: 1,
  },
  title: {
    fontWeight: '600',
    fontSize: 13,
    textAlign: 'center',
  },
  secondary: {
    marginTop: 2,
    opacity: 0.85,
    fontSize: 11,
    textAlign: 'center',
    width: '100%',
    flexShrink: 1,
  },
})
